import {useUserService} from '../../service/user/index'
import  {  useEffect, useState } from 'react';
import { IUser } from '../../service/user/interfaces/IUser';
import { useNotificationSnackbar } from '../useNotificationSnackbar';

const useGetUser = (reload: boolean) => {
  const [data, setData] = useState<IUser[]>([]);
  const [error, setError] = useState<any>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { onErrorSnackbar } = useNotificationSnackbar();
  const {getUsers} = useUserService()
    useEffect(() => {
      setIsLoading(true)
    const fetchData = async () => {
      try {
        const response = await getUsers();
        if(response?.status === 200) {
            setData(response?.data);
        }
        else {
          onErrorSnackbar(response.data)
        }
      } catch (err) {
        setError(err);
      }
      finally {
        setIsLoading(false)
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

    
  
  return {
    data,
    error,
    isLoading
  };
};

export default useGetUser;
